import React from 'react';
// images
import womanDrinkingCoffee from  './images/estate-planning-quiz.webp';
// styles import
import { ExperienceCalloutStyled } from './styles';

export default () => (
  <ExperienceCalloutStyled
    assistiveText='Do you need an estate plan&#63;'
    isFullWidth
    withBGImage
    sectionId='estate-planning-quiz-callout'
    imageUrl={womanDrinkingCoffee.toString()}
    headingText='Do you need an estate plan&#63;'
    buttonText='Take our quiz'
    ariaLabel='Take our estate quiz.'
    linkUrl='/life-and-money/quiz/do-you-need-an-estate-plan/'
    withHoverShadow={false}
    moduleName='quiz-callout-module'
    moduleVariation='A'
    backgroundVariant='lightA'
    calloutBackgroundVariant='lightC'
    calloutThemeType='lightTheme'
    themeType='lightTheme'
    disableLazyLoad
  />
);
